(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-related/assets/react/components/payment-success-info.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-related/assets/react/components/payment-success-info.js');

'use strict';

const Icon = svs.ui.ReactIcon;
const PaymentSuccessInfo = _ref => {
  let charityId = _ref.charityId;
  const titleText = charityId === -1 ? 'Din lyckoplats är betald - bara en sak kvar!' : 'Din lyckoplats är betald';
  return React.createElement("div", {
    className: "align-center padding-1 margin-top-1"
  }, React.createElement(Icon, {
    icon: "thumbs-up",
    size: "900",
    className: "margin-bottom-2"
  }), React.createElement("h1", {
    className: "f-bold h3 margin-bottom"
  }, titleText), Boolean(charityId) && charityId !== -1 && React.createElement(React.Fragment, null, React.createElement("h2", {
    className: "f-bold h3"
  }, "Lycka till!"), React.createElement("p", null, "Se dina lagda spel i ", React.createElement("a", {
    href: svs.core.urlMapping.get('myBetsHome')
  }, "Mina spel"), ".")));
};
setGlobal('svs.lyckoplatsen.components.page_related.react.components', {
  PaymentSuccessInfo
});

 })(window);